import { useState } from 'react';
import AuthService from '../../../services/auth_service';

const ForgotPassword = ({ logout, message}) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleanEmail = email?.trim();
    if (!cleanEmail) {
      message("Por favor, ingresa tu correo electronico", "error");
      return;
    }
    setLoading(true);
    try {
      const result = await AuthService.recoverPassword(cleanEmail);
      if (logout(result)) return;
      if (result) {
        message(
          `Se enviara un correo de recuperacion a ${cleanEmail}. Por favor, revisa la bandeja de entrada`,
          "success"
        );
        setEmail('');
        return;
      }
      message(`La cuenta ${cleanEmail} no esta registrada o no existe`, "error");
    } catch (err) {
      message(err?.message ? `Recuperacion de clave: ${err.message}` : "Recuperacion de clave: ocurrio un error", "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    loading,
    setEmail,
    handleSubmit
  };
};

export default ForgotPassword;
